import { CSSObject } from '@chakra-ui/react';

export const LinkContainer = () => ({
  borderBottom: '1px dashed',
  borderBottomColor: 'blackAlpha.300',
  borderRadius: 'unset',
  px: '0',
  py: '2',
  mb: 'unset',
  mx: '2',
  w: 'auto',
  mt: '-0.5',
  bg: 'transparent',
  _hover: {
    bg: 'blackAlpha.100',
  },
});

export const BoxNextToJumpContainer: CSSObject = {
  bg: 'white',
  mx: '0',
  borderRadius: 'base',
  border: '2px',
  borderColor: '#FFE6B6',
  mb: '2',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35), 0px 0px 0px 2px #000 inset',
};

export const Icon: CSSObject = {
  color: 'beta.300',
  bgGradient: 'linear(to-b, gamma.500, gamma.700)',
  borderRadius: 'base',
  boxShadow:
    '0px 2px 5px 0px rgba(0, 0, 0, 0.25), 0px 1px 1px 0.5px #9F9CFD inset',
};

export const TextRace: CSSObject = {
  color: 'gray.700',
  fontFamily: 'Roboto',
  fontSize: 'xs',
  fontStyle: 'normal',
  lineHeight: 'normal',
  fontWeight: 'medium',
};

export const TextNumber: CSSObject = {
  bg: 'beta.500',
  color: 'beta.300',
  h: '4',
  py: '0',
  pt: '0.5',
  borderRadius: 'base',
};

export const BoxHeading: CSSObject = {
  display: 'none',
};

export const FlexWrapper: CSSObject = {
  '.state-inprogress': {
    color: ['white', 'beta.900'],
  },
  '.chakra-badge': {
    borderRadius: 'sm',
    h: '4',
    minH: '4',
    py: '0',
    mr: '0.5',
    color: 'alpha.800',
  },
};
